export default __webpack_public_path__ + "static/media/email.dfb795f1.svg";